// src/components/DropDownAgeGroup.js
import React, { useEffect, useState } from "react";
import { apiFetch } from "../utils/wkCommon";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function DropDownCategoryAgeGroup({
  value,
  onChange,
  onSelectOption,
  placeholder = "-- pilih Age Group --",
  disabled = false,
  showLabel = false,
}) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let mounted = true;
    (async () => {
      setLoading(true);
      try {
        // ambil list category age groups (sama pola dengan DropDownArea)
        const path = `/api/category-age-groups?pagination[pageSize]=200&fields%5B%5D=name&sort%5B0%5D=name%3Aasc`;
        const data = await apiFetch(path);
        const arr = data?.data ?? [];
        if (!mounted) return;
        // map ke bentuk { id, name }
        setOptions(arr.map(a => ({ id: a.id, name: a.attributes?.name ?? a.name ?? "" })));
      } catch (err) {
        console.error("DropDownCategoryAgeGroup fetch error:", err);
        setOptions([]);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => (mounted = false);
  }, []);

  return (
    <div style={{ marginBottom: "0.75rem", fontSize: "0.95rem" }}>
      { showLabel && ( <label style={{ display: "block", marginBottom: "0.375rem", color: "#2b4a84", fontWeight: 600 }}>Category Age Group</label> ) }
      <select
        name="category_age_groups"
        value={value ?? ""}
        onChange={(e) => {
          const raw = e.target.value;
          const id = raw ? (Number(raw) || raw) : null;
          onChange && onChange(id);
          const opt = options.find(o => String(o.id) === String(id)) ?? null;
          if (typeof onSelectOption === "function") onSelectOption(opt);
        }}
        disabled={disabled || loading}
        style={{ width: "100%", padding: "0.625rem", border: "2px solid #2b4a84", borderRadius: 6 }}
      >
        <option value="">{placeholder}</option>
        {options.map(opt => <option key={opt.id} value={opt.id}>{opt.name}</option>)}
      </select>
      {loading && <div style={{ fontSize: "0.75rem", marginTop: 6 }}>Memuat daftar Age Group…</div>}
    </div>
  );
}
